import { render, staticRenderFns } from "./_staff.vue?vue&type=template&id=5795c8fd&scoped=true&"
import script from "./_staff.vue?vue&type=script&lang=js&"
export * from "./_staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795c8fd",
  null
  
)

export default component.exports